// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
const FAQS_REQUEST_PAGE_DATA = 'FAQS_REQUEST_PAGE_DATA';
const FAQS_REQUEST_PAGE_DATA_SUCCESS = 'FAQS_REQUEST_PAGE_DATA_SUCCESS';

export {
  FAQS_REQUEST_PAGE_DATA,
  FAQS_REQUEST_PAGE_DATA_SUCCESS,
};
